/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { tourHasExternalGuestTypes } from '../utils/guestTypesUtils';
import { COMMERCIAL_ACCOUNT_TYPE } from '../constants';

const useTourList = () => {
    const [tourListState, setTourListState] = useState({ tourList: [] });
    const guestTypes = useSelector((state) => state.timedEntry.facility.guest_types);
    const accountType = useSelector((state) => state.timedEntry.accountType.accountType);
    const filteredTourIds = useSelector(
        (state) => state.timedEntry.filters.filteredTourIds
    );
    const tourList = useSelector((state) => state.timedEntry.tours.tourList);
    const tourMap = useSelector((state) => state.timedEntry.tours.tourMap);

    /**
     * Create sorted list of tickets to display
     */
    useEffect(() => {
        let toursToDisplay = !isEmpty(filteredTourIds)
            ? filteredTourIds.map((tourId) => tourMap[tourId])
            : tourList;

        if (accountType === COMMERCIAL_ACCOUNT_TYPE) {
            //we do not show non commercial tours to commercial users
            const filteredToursToDisplay = [];
            toursToDisplay.forEach((item) => {
                if (item?.is_commercial_quota) {
                    filteredToursToDisplay.push(item);
                }
            });
            toursToDisplay = filteredToursToDisplay;
        }

        toursToDisplay = toursToDisplay.filter((tour) => {
            return tourHasExternalGuestTypes(guestTypes, tour);
        });

        setTourListState((prevState) => ({ ...prevState, tourList: toursToDisplay }));
    }, [tourList, tourMap, guestTypes, accountType, filteredTourIds]);

    return { ...tourListState, tourMap };
};

export default useTourList;
